// extracted by mini-css-extract-plugin
export var downArrow = "_fu-0";
export var infoTooltipIcon = "_fu-3";
export var label = "_fu-1";
export var optionCard = "_fu-4";
export var upArrow = "_fu-2";